import React from 'react';
import EditorViewer from '@common/editorViewer';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';

import classnames from 'classnames/bind';
import styles from './contents.module.scss';
const cx = classnames.bind(styles);

interface ContentsProps {
  positionDetail: PositionDetailVO;
}

const Contents = ({ positionDetail }: ContentsProps) => {
  const { basicInfo } = positionDetail;

  const getContentsEl = () => {
    switch (basicInfo.applyType) {
      case 'INSIGHT':
        return (
          <div className={cx('infoArea')}>
            <div
              className={cx('infoJobflex')}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: basicInfo?.jobflexDescription ?? '',
              }}
            />
          </div>
        );
      case 'CMS':
        return (
          <div className={cx('infoArea')}>
            <img className={cx('infoCms')} src={basicInfo.jobDescriptionImageUrl ?? ''} alt="" />
          </div>
        );
      case 'ATS':
      default:
        //ATS 미리보기 일 경우 null 전달됨
        return (
          <div className={cx('infoArea')}>
            <div className={cx('infoATS')}>
              <EditorViewer value={basicInfo?.jobDescription} />
            </div>
          </div>
        );
    }
  };

  return <>{getContentsEl()}</>;
};

export default Contents;
